var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65266 0.15153C7.44008 0.359936 7.44008 0.70589 7.64849 0.918464L10.1785 3.45684H0.537686C0.24175 3.45684 0 3.6986 0 3.9987C0 4.2988 0.24175 4.54055 0.537686 4.54055H10.1785L7.64432 7.07894C7.43591 7.29151 7.44008 7.63329 7.64849 7.84587C7.86106 8.05427 8.19868 8.05427 8.41125 7.8417L11.8458 4.38217C11.8916 4.33215 11.9291 4.27796 11.9583 4.21127C11.9875 4.14458 12 4.07373 12 4.00287C12 3.86115 11.9458 3.72777 11.8458 3.62357L8.41125 0.164035C8.20702 -0.052707 7.86523 -0.0568753 7.65266 0.15153Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/arrow-next.b5a2983c67a04de85adef166ee165e71.svg";
export { ForwardRef as ReactComponent };